var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.groups),function(group){return _c('client-grouped-thread-group',{key:group,attrs:{"group-id":group,"threads":_vm.threads},on:{"click":_vm.openThread}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }